export default "__VITE_ASSET__DgsxkHjM__"